// images
import IconMetaSearch from "../assets/images/IconMetaSearch.svg";
import IconSocialAds from "../assets/images/IconSocialAds.svg";
import IconSearchAds from "../assets/images/IconSearchAds.svg";
import IconOtaAds from "../assets/images/IconOtaAds.svg";
import IconPMax from "../assets/images/IconPMax.svg";
import IconSeo from "../assets/images/IconSeo.svg";
import IconCms from "../assets/images/IconCms.svg";
import IconRateMatch from "../assets/images/IconRateMatch.svg";
import IconPushTech from "../assets/images/IconPushTech.svg";
import IconHome from "../assets/images/IconHome.svg";
import IconDisplayAds from "../assets/images/IconDisplayAds.svg";
import IconMetaTravelAds from '../assets/images/IconMetaTravelAds.svg';
import IconAiConnect from "../assets/images/IconAiConnect.svg";

import {
  REACT_APP_ICONCMS_URL,
  REACT_APP_RATEMATCH_URL,
  REACT_APP_ICONSEO_URL,
  REACT_APP_PUSHTECH_URL,
} from "./external_urls";

import { getUserToken } from "../utils/functions/userToken";
import { getUserDetailsFromToken } from "../utils/functions/userTokenDetails";
import { APP_ENABLE_META_TRAVEL_ADS, APP_META_TRAVEL_ADS_ALLOWED_USERNAME } from "./api_urls";

const shouldShowMetaTravelAds = () => {
  // If enabled flag is true, show to all users
  if (APP_ENABLE_META_TRAVEL_ADS === "true") {
    return true;
  }
  
  // If enabled flag is false or not set, check allowed usernames
  const token = getUserToken();
  if (!token) {
    console.log("[Meta Hotel Ads] No token found, hiding menu");
    return false;
  }
  
  const { UserDetails } = getUserDetailsFromToken(token);
  
  // Parse allowed usernames from environment variable (comma-separated)
  const allowedUsernames = APP_META_TRAVEL_ADS_ALLOWED_USERNAME 
    ? APP_META_TRAVEL_ADS_ALLOWED_USERNAME.split(',').map(username => username.trim())
    : ["ravindra.yadav@cendyn.com"];

  return allowedUsernames?.includes(UserDetails?.username) ?? false;

};

export const homepageSideMyMenuItems = (accountId ) => {
  const items = [
  {
    name: "Meta Search",
    icon: IconMetaSearch,
    disabled: false,
    url: `/metasearch/${accountId}`,
  },
  {
    name: "Search ads",
    icon: IconSearchAds,
    disabled: false,
    url: `/searchads/${accountId}`,
  },
  {
    name: "PMax",
    icon: IconPMax,
    disabled: false,
    url: `/pmax-campaign-manager/${accountId}`,
  },
  {
    name: "Display Ads",
    icon: IconDisplayAds,
    disabled: false,
    url: `/display-ads-campaign-manager/${accountId}`,
  },
  {
    name: "AI Connect",
    icon: IconAiConnect,
    disabled: false,
    url: `/ai-connect/${accountId}`,
  },
  ];

  // Only add Meta Hotel Ads if user email is in allowed list
  if (shouldShowMetaTravelAds()) {
    items.push({
      name: "Meta Hotel Ads",
      icon: IconMetaTravelAds,
      disabled: false,
      url: `/meta-travel-ads-campaign-manager/${accountId}`,
    });
  }

  return items;
};
export const drawerItems = (accountId) => {
  const items = [
  {
    name: "Home",
    icon: IconHome,
    disabled: false,
    url: `/home/${accountId}`,
    action: "",
  },
  {
    name: "META",
    icon: IconMetaSearch,
    disabled: false,
    url: `/metasearch/${accountId}`,
    action: "metaSearch",
  },
  {
    name: "SEM",
    icon: IconSearchAds,
    disabled: false,
    url: `/searchads/${accountId}`,
    action: "SearchAdsPage",
  },
  {
    name: "PMAX",
    icon: IconPMax,
    disabled: false,
    url: `/pmax-campaign-manager/${accountId}`,
    action: "PMax",
  },
  {
    name: "D-Ads",
    icon: IconDisplayAds,
    disabled: false,
    url: `/display-ads-campaign-manager/${accountId}`,
    action: "DAds",
  },
    {
    name: "AI",
    icon: IconAiConnect,
    disabled: false,
    url: `/ai-connect/${accountId}`,
    action: "aiConnect",
  },
  ];

  // Only add Meta Hotel Ads if user email is in allowed list
  if (shouldShowMetaTravelAds()) {
    items.push({
      name: "Travel",
      icon: IconMetaTravelAds,
      disabled: false,
      url: `/meta-travel-ads-campaign-manager/${accountId}`,
      action: "MetaTravel",
    });
  }

  return items;
};

export const PRODUCT_MENU_LIST = [
  {
    heading: "Paid Ads",
    className: "split",
    menuItems: [
      {
        icon: IconMetaSearch,
        text: "META SEARCH",
        url: "/",
      },
      {
        icon: IconSearchAds,
        text: "SEARCH ADS",
        external: true,
        url: "/",
      },
      {
        icon: IconPMax,
        text: "PMAX",
        external: true,
        url: "/",
      },
    ],
  },
  {
    heading: "Website",
    menuItems: [
      {
        icon: IconSeo,
        text: "SEO",
        url: REACT_APP_ICONSEO_URL,
      },
      {
        icon: IconCms,
        text: "CMS",
        url: REACT_APP_ICONCMS_URL,
      },
    ],
  },
  {
    heading: "Rate Match",
    menuItems: [
      {
        icon: IconRateMatch,
        text: "RATE MATCH",
        url: REACT_APP_RATEMATCH_URL,
      },
    ],
  },
  {
    heading: "CRM",
    menuItems: [
      {
        icon: IconPushTech,
        text: "PUSHTECH",
        url: REACT_APP_PUSHTECH_URL,
      },
    ],
  },
];

export const homepageSideMoreMenuItems = [
  {
    name: "SOCIAL ADS",
    icon: IconSocialAds,
    disabled: false,
  },
  {
    name: "OTA ADS",
    icon: IconOtaAds,
    disabled: false,
  },
];

export const homepageMenuItems = (accoundId) => [
  {
    id: "settings",
    label: "Settings",

    children: [
      {
        id: "bidding-center",
        label: "Bidding Center",
        link: `/bidding-center/${accoundId}`,
      },
      {
        id: "bidding-offline",
        label: "Bidding Offline",
        link: `/bidding-offline/${accoundId}`,
      },
    ],
  },
  {
    id: "reports",
    label: "Reports",

    children: [
      {
        id: "report-center",
        label: "Report Center",
        link: `/report-center/${accoundId}?product=metaSearch`,
      },
      {
        id: "alert-center",
        label: "Alert Center",
        link: `/alert-center/${accoundId}?product=metaSearch`,
      },
    ],
  },

  { id: "groups", label: "Groups", link: `/groups/${accoundId}?product=metaSearch` },

  {
    id: "reservations",
    label: "Reservations",
    link: `/reservations/${accoundId}?product=metaSearch`,
  },
];

export const searchAdspageMenuItems = (accountId ) => [
  {
    id: "search-ads",
    label: "Search Ads",
    children: [
      {
        id: "shared-budget-reporting",
        label: "Shared Budget",
        link: "sharedBudget",
      },
      {
        id: "keywords-management",
        label: "Keywords",
        link: `/keywords-management/${accountId}`,
      },
    ],
  },

  {
    id: "reports",
    label: "Reports",

    children: [
      {
        id: "report-center",
        label: "Report Center",
        link: `/report-center/${accountId}?product=SearchAdsPage`,
      },
      {
        id: "alert-center",
        label: "Alert Center",
        link: `/alert-center/${accountId}?product=SearchAdsPage`,
      },
    ],
  },
  { id: "groups", label: "Groups", link: `/groups/${accountId}?product=SearchAdsPage` },
];

export const pMaxpageMenuItems = (accountId ) => [
  {
    id: "reports",
    label: "Reports",

    children: [
      {
        id: "report-center",
        label: "Report Center",
        link: `/report-center/${accountId}?product=PMax`,
      },
      {
        id: "alert-center",
        label: "Alert Center",
        link: `/alert-center/${accountId}?product=PMax`,
      },
    ],
  },
  { id: "groups", label: "Groups", link: `/groups/${accountId}?product=PMax` },
];
export const displayAdspageMenuItems = (accountId) => [
  
  {
    id: "reports",
    label: "Reports",

    children: [
      {
        id: "report-center",
        label: "Report Center",
        link: `/report-center/${accountId}?product=displayAds`,
      },
      {
        id: "alert-center",
        label: "Alert Center",
        link: `/alert-center/${accountId}?product=displayAds`,
      },
    ],
  },

  { id: "groups", label: "Groups", link: `/groups/${accountId}?product=displayAds` },

  {
    id: "reservations",
    label: "Reservations",
    link: `/reservations/${accountId}?product=displayAds`,
  },
];

export const aiConnectpageMenuItems = (accountId) => [

  {
    id: "reports",
    label: "Reports",

    children: [
      {
        id: "report-center",
        label: "Report Center",
        link: `/report-center/${accountId}?product=displayAds`,
      },
      {
        id: "alert-center",
        label: "Alert Center",
        link: `/alert-center/${accountId}?product=displayAds`,
      },
    ],
  },

  { id: "groups", label: "Groups", link: `/groups/${accountId}?product=displayAds` },

  {
    id: "reservations",
    label: "Reservations",
    link: `/reservations/${accountId}?product=displayAds`,
  },
];
export const metaTravelAdspageMenuItems = (accountId ) => [
  {
    id: "settings",
    label: "Settings",

    children: [
      { id: "groups", label: "Groups", link: `/groups/${accountId}?product=metaSearch` },
      {
        id: "bidding-center",
        label: "Bidding Center",
        link: `/bidding-center/${accountId}`,
      },
      {
        id: "bidding-offline",
        label: "Bidding Offline",
        link: `/bidding-offline/${accountId}`,
      },
    ],
  },
  {
    id: "reports",
    label: "Reports",

    children: [
      {
        id: "report-center",
        label: "Report Center",
        link: `/report-center/${accountId}?product=metaSearch`,
      },
      {
        id: "alert-center",
        label: "Alert Center",
        link: `/alert-center/${accountId}?product=metaSearch`,
      },
    ],
  },
  {
    id: "reservations",
    label: "Reservations",
    link: `/reservations/${accountId}?product=metaSearch`,
  },
];
